// src/pages/ServicesPage.js
import React from "react";
import { Link } from "react-router-dom";
import { FaUserNurse, FaHandsHelping, FaBrain, FaRunning, FaProcedures, FaBandAid } from "react-icons/fa";

const ServicesPage = () => {
  const services = [
    {
      icon: <FaUserNurse />,
    title: "Advanced Nursing Care",
    description:
      "Comprehensive nursing support tailored for patients with critical and chronic health conditions, provided by skilled professionals.",
    link: "/advanced-nursing-care"
  },
  {
    icon: <FaHandsHelping />,
    title: "Basic Supportive Care",
    description:
      "Assistance with daily living activities to ensure safety, comfort, and improved quality of life at home.",
    link: "/basic-supportive-care"
  },
  {
    icon: <FaBrain />,
    title: "Dementia Care",
    description:
      "Specialized, compassionate care designed for individuals with dementia, ensuring safety, patience, and understanding.",
    link: "/dementia-care"
  },
  {
    icon: <FaRunning />,
    title: "Physiotherapy",
    description:
      "Guided physical therapy sessions to restore mobility, strength, and independence after illness, surgery, or injury.",
    link: "/physiotherapy"
  },
  {
    icon: <FaProcedures />,
    title: "Pre & Post-Operative Care",
    description:
      "Professional medical support before and after surgery, ensuring smooth recovery, proper wound care, and monitoring.",
    link: "/pre-post-operative-care"
  },
  {
    icon: <FaBandAid />,
    title: "Wound Dressing",
    description:
      "Expert wound dressing and monitoring services to promote faster healing and prevent infections at home.",
    link: "/wound-dressing"
  },
  ];

  return (
    <div
      style={{
        padding: "3rem 1.5rem",
        maxWidth: "1200px",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "2.5rem", marginBottom: "2rem", color: "#333" }}>
        Our Services
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "1.5rem",
        }}
      >
        {services.map((service, idx) => (
          <div
            key={idx}
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "2rem 1.5rem",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
            }}
          >
            <div style={{ fontSize: "2rem", color: "#ff6b6b", marginBottom: "1rem" }}>
              {service.icon}
            </div>
            <h3 style={{ fontSize: "1.5rem", marginBottom: "0.8rem", color: "#222" }}>
              {service.title}
            </h3>
            <p style={{ fontSize: "1rem", color: "#555", marginBottom: "1.2rem" }}>
              {service.description}
            </p>
            <Link
              to={service.link}
              style={{
                display: "inline-block",
                padding: "10px 20px",
                background: "#ff6b6b",
                color: "#fff",
                borderRadius: "8px",
                fontWeight: "600",
                textDecoration: "none",
                transition: "background 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.background = "#ff4040")}
              onMouseLeave={(e) => (e.target.style.background = "#ff6b6b")}
            >
              Learn More
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
